import clsx from 'clsx'

import { RowProps } from './row.types'

const Row = ({ children, className, 'data-test': dataTest, ...rest }: RowProps) => {
  const classes = clsx('hot-row', className)

  return (
    <div data-test={dataTest} className={classes} {...rest}>
      {children}
    </div>
  )
}

export default Row
